<template>
  <div>
    <p>{{$t('campaign.triggerType')}}: {{ triggerType }}</p>
    <p>{{$t('campaign.startDate')}}: {{ startDate }}</p>
    <p>{{$t('campaign.hour')}}: {{ schedule.time }}</p>
    <p v-if="schedule.endDate">{{$t('campaign.endDate')}}: {{ endDate }}</p>

    <template v-if="schedule.type === 'week'">
      <p>{{$t('campaign.repeatEvery')}}: {{ schedule.recurrence.interval }} {{ weekLabel }}</p>
      <p>{{$t('campaign.weekdays')}}: {{ weekdays.join(', ') }}</p>
    </template>

    <template v-if="schedule.type === 'month' && schedule.recurrence.hasOwnProperty('dayOfMonth')">
      <p>{{$t('campaign.dayOfMonth')}}: {{ schedule.recurrence.dayOfMonth }}</p>
      <p>{{$t('campaign.repeatEvery')}}: {{ schedule.recurrence.interval }} {{ monthLabel }}</p>
    </template>

    <template v-if="schedule.type === 'month' && schedule.recurrence.hasOwnProperty('week')">
      <p>{{$t('campaign.repeatEvery')}}: {{ schedule.recurrence.interval }} {{ monthLabel }}</p>
      <p>{{$t('campaign.whichWeekOfTheMonth')}}: {{ schedule.recurrence.week }}</p>
      <p>{{$t('campaign.weekdays')}}: {{ weekdays.join(', ') }}</p>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    schedule: {
      type: Object,
      required: true
    },
    triggerTypeArray: {
      type: Array,
      required: true
    },
    weekdaysArray: {
      type: Array,
      required: true
    }
  },
  computed: {
    triggerType () {
      if (!this.schedule.type) return ''
      return this.triggerTypeArray.find(trigger => trigger.value === this.schedule.type).name
    },
    weekdays () {
      if (!this.schedule.recurrence.weekdays || this.schedule.recurrence.weekdays.length === 0) return []
      const filteredWeekDays = this.weekdaysArray.filter(weekday => this.schedule.recurrence.weekdays.includes(weekday.value))
      const weekdaysNamesList = filteredWeekDays.map(weekday => weekday.name)
      return weekdaysNamesList
    },
    weekLabel () {
      return this.schedule.recurrence.interval > 1 ? this.$t('campaign.weeks') : this.$t('campaign.week')
    },
    monthLabel () {
      return this.schedule.recurrence.interval > 1 ? this.$t('campaign.months') : this.$t('campaign.month')
    },
    startDate () {
      if (!this.schedule.startDate) return ''
      return this.formatDate(this.schedule.startDate)
    },
    endDate () {
      if (this.schedule.endDate) {
        return this.formatDate(this.schedule.endDate)
      }
      return ''
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY')
    }
  }
}
</script>
